import type { FC } from 'react';
import React from 'react';
import { ModalDesktop } from '@alfalab/core-components-modal/desktop';

import type { TWrapperProps } from '../../models';

export const DesktopWrapper: FC<TWrapperProps> = ({ children, isOpened, onClose, title }) => (
    <ModalDesktop onClose={onClose} open={isOpened} size="l">
        <ModalDesktop.Header hasCloser title={title} />
        <ModalDesktop.Content>{children}</ModalDesktop.Content>
    </ModalDesktop>
);
